/**
 * Mutators
 * @type {Map<String, Function>}
 */
const mutators = new Map();

mutators.set('number', (value, config) => {
    return new Intl.NumberFormat(config.locale ?? undefined).format(value);
});

mutators.set('suffix', (value, config) => {
    return value + (config.hasOwnProperty('suffix') && config.suffix.length > 0 ? ' ' + config.suffix : '');
});

mutators.set('splitter', (value, config) => {
    let split = value.split(config.separator);

    return config.firstElement ? split[0] : split[split.length - 1];
})

export default mutators;
